export const getUiScale = () => {
  if (typeof document === 'undefined') return 1
  const value = Number.parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--app-ui-scale')
  )
  return value > 0 ? value : 1
}

// Dragging libraries and modal coordinates use unscaled CSS pixels.
export const getAppViewport = () => {
  const scale = getUiScale()
  return { width: window.innerWidth / scale, height: window.innerHeight / scale }
}

// MUI positions portals using getBoundingClientRect (physical pixels).
// Keep that coordinate system unscaled, then scale the visible popup contents.
export const getMuiOverlayContainer = () => {
  let container = document.getElementById('mui-overlay-root')
  if (!container) {
    container = document.createElement('div')
    container.id = 'mui-overlay-root'
    document.body.appendChild(container)
  }
  return container
}

/** @type {Partial<import('@popperjs/core').Modifier<'scaledAutocompleteWidth', {}>>} */
export const autocompleteWidthModifier = {
  name: 'scaledAutocompleteWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    if (state.elements.popper.classList.contains('MuiAutocomplete-popper')) {
      state.styles.popper.width = `${state.elements.reference.getBoundingClientRect().width}px`
    }
  }
}
